import { Menu } from 'sharebase/domain';
import { MenuItemFactory } from 'sharebase/factories';

export class MenuFactory {
	public static $inject = [
		'$q',
		'sbMenuItemFactory'
	];

	constructor(
		private readonly $q:ng.IQService,
		private readonly sbMenuItemFactory:MenuItemFactory
	){
	}
	
	public create() {
		return new Menu(this.$q, this.sbMenuItemFactory);
	}
}


// WEBPACK FOOTER //
// ./src/sharebase/factories/menuFactory.ts